export default __webpack_public_path__ + "static/media/illust-key-visual.875b9e7f.svg";